import type { Props } from './types';

import { styled } from 'styled-components';

import { LeftColSC } from '../common/Common';

const MobileNavSC = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
  justify-content: center;
  align-items: center;

  @media (min-width: ${(props) => props.theme.devices.tablet}) {
    display: none;
  }
`;

const MobileNav = ({ backButton, currentStep, steps }: Props) => {
  const stepCounter = `${currentStep} / ${Object.keys(steps).length}`;

  return (
    <MobileNavSC>
      {backButton ? (
        <>
          <LeftColSC>{backButton}</LeftColSC>
          {stepCounter} - {steps[currentStep]}
        </>
      ) : (
        <>
          <LeftColSC>{stepCounter}</LeftColSC>
          {steps[currentStep]}
        </>
      )}
    </MobileNavSC>
  );
};

export default MobileNav;
